const CHANNEL = 'akcent-radio'
const POLL_INTERVAL = 30000

const players = Array.from(document.querySelectorAll('.js-radio-player'))
if (players.length) setup(players)

function setup(players) {
  const { streamUrl, nowPlayingUrl, playLabel, pauseLabel, station } = players[0].dataset
  const channel = 'BroadcastChannel' in window ? new BroadcastChannel(CHANNEL) : null
  const audio = new Audio()
  audio.preload = 'none'

  let state = 'idle'
  let track = ''
  let session = 0
  let pollTimer = null

  const isActive = () => state === 'loading' || state === 'playing'

  function render() {
    players.forEach((player) => {
      player.dataset.state = state
      const toggle = player.querySelector('.js-radio-toggle')
      toggle.setAttribute('aria-label', isActive() ? pauseLabel : playLabel)
      toggle.setAttribute('aria-pressed', String(isActive()))
      const trackLine = player.querySelector('.js-radio-track')
      if (!trackLine) return
      if (state === 'error') trackLine.textContent = trackLine.dataset.error
      else trackLine.textContent = (isActive() && track) || trackLine.dataset.idle
    })
    if ('mediaSession' in navigator && isActive()) {
      navigator.mediaSession.metadata = new MediaMetadata({ title: track || station, artist: track ? station : '' })
    }
  }

  function claimMediaSession() {
    if (!('mediaSession' in navigator)) return
    navigator.mediaSession.setActionHandler('play', play)
    navigator.mediaSession.setActionHandler('pause', () => stop())
    navigator.mediaSession.setActionHandler('stop', () => stop())
  }

  function play() {
    session += 1
    const current = session
    audio.src = streamUrl
    claimMediaSession()
    state = 'loading'
    render()
    audio.play().catch((error) => {
      if (current !== session || error.name === 'AbortError') return
      disconnect()
      state = error.name === 'NotAllowedError' ? 'idle' : 'error'
      render()
    })
    poll(current)
  }

  function stop(nextState = 'idle') {
    disconnect()
    state = nextState
    track = ''
    render()
  }

  function disconnect() {
    session += 1
    clearTimeout(pollTimer)
    audio.removeAttribute('src')
    audio.load()
  }

  async function poll(current) {
    try {
      const response = await fetch(nowPlayingUrl, { headers: { Accept: 'application/json' } })
      const { title } = response.ok ? await response.json() : {}
      if (current !== session) return
      track = title || ''
      render()
    } catch {
      if (current !== session) return
    }
    pollTimer = setTimeout(() => poll(current), POLL_INTERVAL)
  }

  audio.addEventListener('playing', () => {
    channel?.postMessage('play')
    state = 'playing'
    render()
  })
  audio.addEventListener('waiting', () => {
    if (state !== 'playing') return
    state = 'loading'
    render()
  })
  audio.addEventListener('error', () => {
    if (audio.getAttribute('src')) stop('error')
  })
  audio.addEventListener('pause', () => {
    if (audio.getAttribute('src')) stop()
  })

  channel?.addEventListener('message', () => {
    if (isActive()) stop()
  })

  players.forEach((player) => {
    player.querySelector('.js-radio-toggle').addEventListener('click', () => (isActive() ? stop() : play()))
  })

  render()
}
